import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { DistrictGroupService } from '../services/district-group.service';
import { DistrictGroup } from '@app/shared';


@Injectable({
    providedIn: 'root'
})
export class DistrictGroupResolverService {

    constructor(
        private districtGroupService: DistrictGroupService,
        private router: Router
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.paramMap.get('id');

        if (id === null) {
            return of(new DistrictGroup());
        }

        return this.districtGroupService.get(+id).pipe(
            map(item => {
                if (item) {
                    return item;
                }
                this.router.navigate(['/admin/district-group-list']);
                return null;
            })
        );
    }

}
